// extracted by mini-css-extract-plugin
export default {"Root":"FileInfo_Root__RHzWd","title":"FileInfo_title__P1Zlx"};